import axios from "axios";

export const situacionesService = {
  getSituaciones
};

async function getSituaciones() {
  try {
    let response = await axios.get("https://wsrfa.sannicolasciudad.gob.ar/listados/dtSituacion.php?condicion=DESTINO='CC'&orden=DETALLE_SITUACION");


    return response.data;
  }
  catch (err) {
    console.log(err);
    return [];
  }
}
